import PropTypes from "prop-types";
import styles from "./Header.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

/**
 * Used throughout the app to go back to previous pages.
 */
export function Header({ onClick, header, disabled }) {
  return (
    // <div className={styles.container} onClick={onClick}>
    <div
      className={`${styles.container} ${disabled ? styles.disabled : ""}`}
      onClick={!disabled ? onClick : null}
    >
      <div className={styles.chevron}>
        <FontAwesomeIcon icon={faChevronLeft} className={styles.chevronIcon} />
      </div>
      <div>{header}</div>
    </div>
  );
}

Header.propTypes = {
  /**
   * Function that directs the user to the home page if they are not already there.
   */
  onClick: PropTypes.func,
  /**
   * Label for the header
   */
  header: PropTypes.string,
};
